import React from "react";
import { IconProp } from ".";
export default function CircleMenuIcon(props: IconProp) {
    const { width, height, hoverColor, color = "black" } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill={color} />
            <circle cx="7" cy="12" r="1.5" transform="rotate(-90 7 12)" fill="white" />
            <circle cx="12" cy="12" r="1.5" transform="rotate(-90 12 12)" fill="white" />
            <circle cx="17" cy="12" r="1.5" transform="rotate(-90 17 12)" fill="white" />
        </svg>
    );
}
